import { render, staticRenderFns } from "./blogger_list.vue?vue&type=template&id=0ecb50f2&scoped=true"
import script from "./blogger_list.vue?vue&type=script&lang=ts"
export * from "./blogger_list.vue?vue&type=script&lang=ts"
import style0 from "./blogger_list.vue?vue&type=style&index=0&id=0ecb50f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb50f2",
  null
  
)

export default component.exports